module.exports = __webpack_public_path__ + "assets/img/Fotolia_161923883_XS.021bb5d3.jpg";